<template>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';

const MV_URL = process.env.MUSICVERSE_URL;
const BASE_URL = process.env.BASE_URL;
export default {
  name: 'DirectSubscribePage',
  data: () => ({
    isMobileLogin: false,
    mv_url: MV_URL,
    subscribeData: {
      country: '',
      currency: '',
      identifier: '',
      price: 0,
      lowest_price: 0,
      recurring: true,
      defaultPrice: 0,
      paymentMethod: 'credit_card',
      checkout_url: '',
    },
    recurring: true,
    oneTimeMonth: 1,
    paymentMethod: null,
    inputPrice: 100,
  }),
  computed: {
    ...mapGetters('CreditsAmountModule', ['listSubscriptionPrice']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getNextPage']),
    ...mapGetters('AuthModule', ['getUser', 'accessToken', 'getFromApps']),
  },
  watch: {
    listSubscriptionPrice: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listSubscriptionPrice != undefined && this.listSubscriptionPrice != null) {
          const subs = this.listSubscriptionPrice;
          this.subscribeData = {
            ...subs,
            country: subs.country,
            currency: subs.currency,
            identifier: subs.identifier.replaceAll('-', '_'),
            price: subs.price,
            defaultPrice: subs.price,
            recurring: true,
          };
        }
      },
    },
  },
  async mounted() {
    if (this.$route.query._t !== undefined && this.$route.query.price !== undefined && this.$route.query.method !== undefined && this.$route.query.recurring !== undefined) {
      this.inputPrice = this.$route.query.price;
      this.recurring = parseInt(this.$route.query.recurring) === 1;
      this.paymentMethod = this.$route.query.method;
      this.oneTimeMonth = !this.recurring && this.$route.query.interval !== undefined ? this.$route.query.interval : 1
      await this.removeAuthentication({ accessToken: this.accessToken });
      this.isMobileLogin = true;
      const response = await this.requestMobileAuth(this.$route.query._t);
      if (response) {
        await this.requestDetailUser();
        await this.requestListSubscription();
        this.subscribeData = {...this.subscribeData, price: this.inputPrice, recurring: this.recurring, paymentMethod: this.paymentMethod}
        await this.pay();
        // const session = await this.requestUpdatePayment({
        //   success_url: `${BASE_URL}/#/update-payment-success`,
        //   failed_url: `${BASE_URL}/#/update-payment-failed`,
        //   cancel_url: `${BASE_URL}/#/update-payment-failed`,
        // });
        // if (session) {
        //   this.setLoading();
        //   await this.$stripe.redirectToCheckout({ sessionId: session.id });
        //   this.unsetLoading();
        // } else {
        //   this.$router.push({ name: 'UpdatePaymentFailedPage' });
        // }
      } else {
        this.$router.push({ name: 'UpdatePaymentFailedPage' });
      }
    }
  },
  methods: {
    ...mapActions('AuthModule', ['requestMobileAuth', 'removeAuthentication', 'requestDetailUser']),
    ...mapActions('NotificationModule', ['setNextPage', 'setLoading', 'unsetLoading']),
    ...mapActions('CreditsAmountModule', ['requestListSubscription']),
    ...mapActions('PaymentModule', ['setPaymentDataSubscription', 'removePaymentDataSubscription',
      'requestMakePaymentSubscription', 'requestMakePaymentSubscriptionWeChat',
      'requestMakePaymentSubscriptionPayMongo', 'requestConfirmPaymentSubscriptionPayMongo','requestUpdatePayment']),
    async pay() {
      if (this.recurring) {
        this.subscribeData = { ...this.subscribeData, paymentMethod: 'credit_card' };
        await this.payStripe();
      } else {
        this.subscribeData = { ...this.subscribeData, paymentMethod: this.paymentMethod };
        if (this.paymentMethod === 'credit_card' || this.paymentMethod === 'wechat') {
          await this.payStripe();
        } else {
          await this.payMongo();
        }
      }
    },
    async payStripe() {
      let dataSend = {
        currency: this.subscribeData.currency,
        amount: this.subscribeData.price,
        identifier: this.subscribeData.identifier,
        recurring: this.subscribeData.recurring,
        success_url: this.getFromApps ? `${BASE_URL}/#/transaction-success` : `${BASE_URL}/#/subscription-success`,
        cancel_url: `${BASE_URL}/#/transaction-failed`,
      };
      if (!this.recurring) {
        dataSend = { ...dataSend, interval: this.oneTimeMonth,amount: this.subscribeData.price };
      }
      const session = this.subscribeData.paymentMethod === 'wechat' ? await this.requestMakePaymentSubscriptionWeChat(dataSend) : await this.requestMakePaymentSubscription(dataSend);
      this.subscribeData = { ...this.subscribeData, session_id: session.id };
      this.setPaymentDataSubscription(this.subscribeData);
      this.setLoading();
      await this.$stripe.redirectToCheckout({ sessionId: session.id });
      this.unsetLoading();
    },
    async payMongo() {
      const price = (this.inputPrice * this.subscribeData.rate).toFixed(2);
      const dataSend = {
        type: this.subscribeData.paymentMethod,
        currency: 'PHP',
        amount: price,
        interval: this.oneTimeMonth,
        identifier: this.subscribeData.identifier,
        success_url: this.getFromApps ? `${BASE_URL}/#/transaction-success` : `${BASE_URL}/#/subscription-success`,
        failed_url: `${BASE_URL}/#/transaction-failed`,
      };
      const session = await this.requestMakePaymentSubscriptionPayMongo(dataSend);
      this.subscribeData = { ...this.subscribeData, session_id: session.data.data.data.id, checkout_url: session.data.checkout_url };
      this.setPaymentDataSubscription(this.subscribeData);
      this.setLoading();
      document.location.href = session.data.checkout_url;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/DirectSubscribe.vue